import React from 'react';
import { Helmet } from 'react-helmet';
import { observer } from 'mobx-react-lite';
import { JoinMindTrust16 } from '../../components/JoinMindTrust';
import { useAppStore } from 'store/app-store.hook';

export const JoinMindTrust16Page = observer(() => {
  const { joinMindtrustPage } = useAppStore().ui;
  return (
    <>
      <Helmet>
        <title>Join MindTrust</title>
      </Helmet>
      <JoinMindTrust16
        step16={joinMindtrustPage.joinMindtrustForm.submit}
        onNext={(submit) => joinMindtrustPage.saveApplicationForm({ submit, nextStep: 17 })}
        goBack={() => joinMindtrustPage.goBack(15)}
      />
    </>
  );
});
